import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { apiService } from "service/ApiService";
import StoreContext from "contexts/StoreContext";
import DateRangeContext from "contexts/DateRangeContext";
import ExportToExcelButton from "views/Components/ExportToExcelButton";
import { exportToExcel, getIntegratorNameById } from "utils/AppUtils";
import PlatformSalesTable from "components/Tables/PlatformSalesTable";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

function PlatformSalesPage() {
  const {
    t,
  } = useTranslation();

  const { storeId, setStoreId } = useContext(StoreContext);
  const { dateRange, setDateRange } = useContext(DateRangeContext);
  const [data, setData] = useState([]);
  const [integrators, setIntegrators] = useState([]);
  const [showLoader, setShowLoader] = useState(true);

  const colsPerRow = 2;
  const rows = [];
  const extrasRows = [];
  for (let i = 0; i < integrators.length; i += colsPerRow) {
    rows.push(integrators.slice(i, i + colsPerRow));
  }

  const refreshData = () => {
    setShowLoader(true);
    apiService
      .post(`api/v1/stores/${storeId}/platform-sales`, {
        fromDate: dateRange[0],
        toDate: dateRange[1],
      })
      .then((resp) => {
        console.log(resp);
        setData(resp);
        setIntegrators([...new Set(resp.map((item) => item.order_integrator_id))]);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setShowLoader(false);
      });
  };

  const formatData = (data) => {
    if (data.length === 0) return [];
    let totalQuantity = 0;
    let totalSummary = 0;
    let formattedData = data.map((row) => {
      totalQuantity += row.quantity;
      totalSummary += row.total;
      return {
        ID: row.product_id,
        [t("tables.headers.product")]: row.product_name,
        [t("tables.headers.platform")]: getIntegratorNameById(row.order_integrator_id),
        [t("tables.headers.quantity")]: Number(row.quantity),
        [t("tables.headers.totalEuro")]: row.total,
      };
    });

    formattedData.push({
      ID: null,
      [t("tables.headers.product")]: t("tables.headers.total"),
      [t("tables.headers.category")]: null,
      [t("tables.headers.quantity")]: totalQuantity,
      [t("tables.headers.totalEuro")]: totalSummary.toFixed(2),
    });

    return formattedData;
  };

  const handleExportData = () => {
    exportToExcel(formatData(data), `platform-sales-${+new Date()}`, "Platform Sales");
  };

  useEffect(() => {
    if (!storeId || !dateRange) return;
    refreshData();
  }, [storeId, dateRange]);

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12" xs="12">
            <ExportToExcelButton handler={handleExportData} disabled={data.length === 0} />
          </Col>
        </Row>
        {showLoader ? (
          <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
            <ClipLoader size={50} color={"#ff6fbc"} />
          </div>
        ) : (
          rows.map((row, rowIndex) => (
            <Row key={rowIndex}>
              {row.map((integrator, colIndex) => (
                <Col key={colIndex} xs={12} md={12}>
                  <PlatformSalesTable integrator={integrator} data={data} />
                </Col>
              ))}
            </Row>
          ))
        )}
      </Container>
    </>
  );
}

export default PlatformSalesPage;
